<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <!-- <vx-tooltip class="position-icon" :text="$t('news.evaluate')" position="top">
                <feather-icon icon="StarIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="evaluateNews" v-show="this.params.data.articleType == 1"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('news.selection')" position="top">
                <feather-icon icon="PieChartIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="selectionNews" v-show="this.params.data.articleType == 2"/>
            </vx-tooltip> -->
            <vx-tooltip class="position-icon" :text="$t('button.edit')" position="top" >
                <feather-icon icon="EditIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" >
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>


export default {
    name: 'CellRendererActions',
    methods: {

        // evaluateNews() {
        //     this.$router.push('/user/evaluate-news?postId=' + this.params.data.id).catch(() => {
        //     })
        // },

        // selectionNews() {
        //     this.$router.push('/user/selection-news?postId=' + this.params.data.id).catch(() => {
        //     })
        // },

        editRecord() {
            this.$router.push('/user/manage-edit-classroom-manager?postId=' + this.params.data.id).catch(() => {
            })
        },

        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá bảng tin này không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post('/post-news-feed/delete?postId=' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();

            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$store.commit('DELETE_NEWS', true);
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    }
}
</script>
<style scoped>

</style>
